/** @format */

import React, { memo, useEffect, useState } from "react";

import PropTypes from "prop-types";
import AdminButton from "components/adminButton";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Slide,
  Grid,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { rateAndTagByAdmin } from "store";
import AdrenaInput from "components/adrenaInput";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UserLabelDialog = (props) => {
  const { setShowDialog, showDialog, userId, userDetaiData } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    if (userDetaiData) {
      if (userDetaiData?.tagsByAdmin?.length >= 1) {
        setLabel(userDetaiData?.tagsByAdmin[0]);
      } else {
        setLabel("");
      }
    }
  }, [userDetaiData]);
  const [label, setLabel] = useState("");
  var theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t, i18n } = useTranslation();

  const handleRating = () => {
    let request = {
      userId: userId,
      updateType: 1,
      tags: [label],
      rating: userDetaiData?.ratingByAdmin,
      language: i18n?.language
    };
    dispatch(rateAndTagByAdmin(request, setShowDialog, t("users.userLabelSuccess")));
  };
  return (
    <>
      <Dialog
        maxWidth="xs"
        open={showDialog}
        PaperProps={{
          style: {
            boxShadow: "none",
            borderRadius: 0,
            width: "330px"
          }
        }}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setShowDialog(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ fontFamily: "setimo", fontWeight: 700, fontSize: 20 }}>
            {t("users.userLabel")}
          </Typography>
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: "white",
            paddingTop: 0
          }}>
          <Typography
            sx={{
              marginBottom: "-0.7rem",
              color: "#212b36",
              fontWeight: 500,
              fontSize: 15,
              display: "block"
            }}>
            {t("users.label")}
          </Typography>
          <AdrenaInput value={label} onChange={(val) => setLabel(val.target.value)} />
        </DialogContent>
        <Grid container sx={{ px: 2.8, pb: 2 }} gap={isMobile ? 1 : 2}>
          <Grid xs={isMobile ? 12 : 5.5}>
            <AdminButton
              fullWidth
              onClick={() => setShowDialog(false)}
              color="primary"
              variant="outlined"
              title="Cancel"
            />
          </Grid>
          <Grid xs={isMobile ? 12 : 5.5}>
            <AdminButton
              disable={label?.length >= 1 ? false : true}
              fullWidth
              title={t("forgotPassword.submit")}
              onClick={() => {
                handleRating();
              }}
              color="primary"
              sx={{ height: "2.5rem" }}
            />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

UserLabelDialog.propTypes = {
  open: PropTypes.any,
  handleClose: PropTypes.any,
  title: PropTypes.string,
  text: PropTypes.string,
  handleAgree: PropTypes.any
};

export default memo(UserLabelDialog);
